import { Box, Flex, Heading, Text } from "@chakra-ui/react"
import TryAgainBtn from "../tryAgainBtn"

function ErrorPage() {
  return (
    <Flex
      w="100%"
      h="100%"
      flexDir="column"
      justifyContent="center"
      alignItems="center"
      gap="1rem"
      role="alert"
    >
      <Heading textAlign="center">Sorry, something went wrong.</Heading>
      <Text maxW="540px" textAlign="center">
        An error has occurred. Our team has logged it, and we are working to
        resolve the issue as soon as possible. Thank you for your patience.
      </Text>
      <TryAgainBtn />
    </Flex>
  )
}

export default ErrorPage
